<template>
  <!-- <v-layout row class="ml-4"> -->
  <v-layout row>
    <v-flex xs12 class="pt-0">
      <v-list class="pt-0">
        <v-list-item-group>
          <v-list-item
            v-for="(child, i) in children"
            :key="i"
            @click="$emit('rip:child', child)">
            <v-list-item-icon class="mr-4">
              <v-icon>
                keyboard_arrow_right
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content >
              <v-list-item-title v-text="`${child.name} (${child.contacts_count})`">
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'ChildList',
  props: ['children'],
};
</script>
